import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Stack, IconButton, InputAdornment, TextField, Link, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { useFormik } from 'formik';
import * as yup from "yup";

import CircularProgress from '@mui/material/CircularProgress';
import { apipost } from '../../../service/api';
import Iconify from '../../../components/iconify';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLogin] = useState(false);
  const [loginMethod, setLoginMethod] = useState('encompass'); // 'encompass' or 'email'

  const encompassInitialValues = {
    username: "",
    password: ""
  };

  const emailInitialValues = {
    emailAddress: "",
    password: ""
  };

  const encompassValidation = yup.object({
    username: yup.string().required("Encompass username is required"),
    password: yup.string().required("Password is required"),
  });

  const emailValidation = yup.object({
    emailAddress: yup.string().email('Invalid email').required("Email is required"),
    password: yup.string().required("Password is required"),
  });

  const Adddata = async (values) => {
    setIsLogin(true);

    let result;
    if (loginMethod === 'encompass') {
      result = await apipost('user/encompass-login', {
        username: values.username,
        password: values.password,
      });
    } else {
      result = await apipost('user/login', {
        emailAddress: values.emailAddress,
        password: values.password,
      });
    }

    if (result && result.status === 200) {
      localStorage.setItem('user', JSON.stringify(result?.data?.user));
      localStorage.setItem('user_id', result?.data?.user?._id);
      localStorage.setItem('userRole', result?.data?.user?.role);
      navigate('/dashboard/app');
    } else {
      navigate('/login');
    }

    setIsLogin(false);
  };

  const formik = useFormik({
    initialValues: loginMethod === 'encompass' ? encompassInitialValues : emailInitialValues,
    validationSchema: loginMethod === 'encompass' ? encompassValidation : emailValidation,
    enableReinitialize: true,
    onSubmit: async (values) => {
      Adddata(values);
    },
  });

  const toggleLoginMethod = () => {
    formik.resetForm();
    setLoginMethod(loginMethod === 'encompass' ? 'email' : 'encompass');
  };

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Stack spacing={3} mb={2}>
          {loginMethod === 'encompass' ? (
            <TextField
              name="username"
              label="Encompass Username"
              value={formik.values.username || ''}
              onChange={formik.handleChange}
              error={formik.touched.username && Boolean(formik.errors.username)}
              helperText={formik.touched.username && formik.errors.username}
            />
          ) : (
            <TextField
              name="emailAddress"
              label="Email"
              value={formik.values.emailAddress || ''}
              onChange={formik.handleChange}
              error={formik.touched.emailAddress && Boolean(formik.errors.emailAddress)}
              helperText={formik.touched.emailAddress && formik.errors.emailAddress}
            />
          )}

          <TextField
            name="password"
            label="Password"
            type={showPassword ? 'text' : 'password'}
            value={formik.values.password}
            onChange={formik.handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
          />
        </Stack>
        <LoadingButton fullWidth size="large" type="submit" variant="contained" disabled={!!isLoading}>
          {isLoading ? <CircularProgress /> : 'Login'}
        </LoadingButton>
      </form>

      <Typography variant="body2" sx={{ mt: 2, textAlign: 'center' }}>
        <Link component="button" type="button" variant="body2" onClick={toggleLoginMethod}>
          {loginMethod === 'encompass' ? 'Sign in with email instead' : 'Sign in with Encompass'}
        </Link>
      </Typography>
    </>
  );
}
